import cx from "clsx"
import { Flex, Icon, Image, Text } from "components/common"
import { memo, useMemo } from "react"
import { localisedValue } from "utils"
import styles from "../../index.module.less"
import { safeJSONParse } from "../../utils"

const ReplyPreview = memo(({ msg, client, selectedStaff }) => {
  const repliedToMessage = useMemo(() => msg?.RepliedToMessage, [msg])
  const getReplyContent = () => {
    if (repliedToMessage) {
      const parsedContent = safeJSONParse(repliedToMessage.content)
      const contentType = repliedToMessage.contentType || parsedContent?.type

      switch (contentType) {
        case "text":
          return {
            type: "text",
            content: parsedContent?.message,
          }
        case "image":
          return {
            type: "image",
            content: "Photo",
            thumbnail: parsedContent?.s3KeyValue
          }
        case "video":
          return {
            type: "video",
            content: "Video",
            thumbnail: parsedContent?.s3KeyValue
          }
        case "audio":
          return {
            type: "audio",
            content: "Voice message",
            icon: "HiMicrophone"
          }
        case "document":
          return {
            type: "document",
            content: "Document",
            icon: "HiDocument"
          }
        case "live_location":
          return {
            type: "location",
            content: "Location",
            icon: "HiMapPin"
          }
        case "location":
          return {
            type: "location",
            content: "Location",
            icon: "HiMapPin"
          }
        default:
          return {
            type: "text",
            content: "Message",
          }
      }
    }
    return null
  }
  const replyData = getReplyContent()

  const getSenderDisplayName = () => {
    if (repliedToMessage?.sentBy === "staff") {
      return <Text>{localisedValue({ object: selectedStaff?.User, key: "name" })}</Text>
    }
    return <Text>{localisedValue({ object: client, key: "name" })}</Text>
  }

  return (
    <div className={cx(styles.replyPreview, "pi-8 pb-4")}>
      <Flex vertical gap={8}>
        <Text className={cx(styles.replySender, "fs12")}>
          {getSenderDisplayName()}
        </Text>
        <Flex align="center" gap={8}>
          <Flex align="center" gap={4}>
            <Icon icon={replyData.icon} className={cx(styles.replyIcon, "fs14")} />
            <Text className={cx(styles.replyMessage, "fs12")}>
              {replyData.content}
            </Text>
          </Flex>
          {(replyData.type === "image" || replyData.type === "video") && replyData.thumbnail && (
            <div className={cx(styles.replyThumbnail, "p-2")}>
              <Image
                src={replyData.thumbnail}
                alt={replyData.content}
                width={40}
                height={40}
                style={{ borderRadius: 4 }}
                fallback={<div className={styles.thumbnailFallback} />}
              />
            </div>
          )}
        </Flex>
      </Flex>
    </div>
  )
})

ReplyPreview.displayName = 'ReplyPreview'

export default ReplyPreview
